"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopiaToggle = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
function TopiaToggle(props) {
    return ((0, jsx_runtime_1.jsxs)("div", { className: (0, classnames_1.default)("flex items-center", props.className), children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: props.id, className: "block text-sm font-medium text-white", children: props.label }), (0, jsx_runtime_1.jsx)("div", { className: "mt-1", children: (0, jsx_runtime_1.jsx)("input", __assign({}, props.inputProps, { type: "checkbox", id: props.id, className: "ml-2   border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm" })) })] }));
}
exports.TopiaToggle = TopiaToggle;
